import { useEffect, useRef, useState } from 'react';
import { FEATURES } from '../utils/constants';

export const useSpeechRecognition = (features, setFeatures, setInputText, onSend) => {
  const [isListening, setIsListening] = useState(false);
  const [error, setError] = useState(null);
  const speechRecognition = useRef(null);

  useEffect(() => {
    if (features[FEATURES.SPEECH_RECOGNITION]) {
      try {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (SpeechRecognition) {
          speechRecognition.current = new SpeechRecognition();
          speechRecognition.current.continuous = false;
          speechRecognition.current.interimResults = false;

          speechRecognition.current.onresult = (event) => {
            const transcript = event.results[0][0].transcript;
            
            const lowercaseTranscript = transcript.toLowerCase();
            // If the transcript contains the word "send message", send the message
            if (lowercaseTranscript.includes('send message')) {
              onSend();
            }
            else {
              setInputText(transcript);
            }
            
            setIsListening(false);
          };

          speechRecognition.current.onerror = (event) => {
            console.error('Speech recognition error:', event.error);
            setError('Speech recognition failed. Please try again.');
            setIsListening(false);
          };

          speechRecognition.current.onend = () => {
            setIsListening(false);
          };
        }
      } catch (err) {
        console.error('Speech recognition setup failed:', err);
        setFeatures(prev => ({
          ...prev,
          [FEATURES.SPEECH_RECOGNITION]: false
        }));
      }
    }
  }, [features, setFeatures, setInputText, onSend]);

  return {
    isListening,
    setIsListening,
    speechRecognition,
    error,
    setError
  };
};